// Discovery.tsx — the Home page: the "Chat with Dooglie" conversation filling the
// main area of the shared app shell (the layout route draws the shell).
import React from 'react';
import DiscoveryConversation from './discoveryConversation';

const Discovery: React.FC = () => (
  <div
    className="dg-card"
    style={{
      // Fill the main area: 100vh minus the .dg-main top+bottom padding.
      height: 'calc(100vh - 120px)',
      display: 'flex',
      marginBottom: 0,
    }}
  >
    <DiscoveryConversation />
  </div>
);
export default Discovery;
